"use client";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { StationsHydrator } from "./components";
import { persistor } from "./persistor";
import { store } from "./store";

interface ReduxProviderProps {
  children: React.ReactNode;
}

const ReduxProvider = ({ children }: ReduxProviderProps) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <StationsHydrator />
        {children}
      </PersistGate>
    </Provider>
  );
};

export default ReduxProvider;
